<div class="login-container">
  <div class="flex flex-col gap-0 login-card">
    <div class="public-forms-header mb-3">
      <a href="https://www.brandshelter.com">
        <img alt="Logo" [src]="logoUrl()">
      </a>
      @if (signupUrl === '/signup') {
        <a class="text-white" [routerLink]="['/signup']" i18n="login|Register new account link">Register a new account</a>
      } @else {
        <a class="text-white" href="https://www.brandshelter.com/sign-up/" i18n="login|Register new account external link">Register a new account</a>
      }
    </div>

    <div class="p-4">
      @if (!tanFormVisible) {
        <form [formGroup]="form" class="flex flex-col gap-5" (ngSubmit)="onSubmit()">
          @if (invalidUserOrPassword) {
            <p-message severity="error" i18n="login|Invalid credentials error">
              Invalid Username or password.
            </p-message>
          }
          <div class="flex flex-col gap-1">
            <label for="login-username" i18n="login|Username field label">Username</label>
            <input pInputText [pAutoFocus]="true" id="login-username" formControlName="username"/>
            @let usernameControl = form.get('username');
            @if (usernameControl?.touched && usernameControl?.errors?.['required']) {
              <p-message i18n="login|Username required error" severity="error" variant="simple" size="small">
                Username is required
              </p-message>
            }
            <small id="login-username-help" i18n="login|Username help text">Only enter your username if SSO is enabled for your domain.</small>
          </div>
          <div class="flex flex-col gap-1">
            <label for="login-password" i18n="login|Password field label">Password</label>
            <p-password inputId="login-password" [toggleMask]="true" [feedback]="false" formControlName="password" [fluid]="true"/>
            <small><a href="/password-reset" class="doc-link" i18n="login|Forgot password link">Forgot username/password?</a></small>
          </div>
          <div class="flex flex-row gap-2">
            <p-checkbox inputId="login-remember-me" formControlName="remember_me" value="" />
            <label class="form-check-label" for="login-remember-me" i18n="login|Remember me checkbox">Remember me</label>
          </div>
          <div class="flex justify-center">
            <ngx-turnstile
              [siteKey]="turnstileSiteKey"
              (resolved)="onCaptchaResolved($event)"
              theme="light"
              [language]="locale"
              size="normal">
            </ngx-turnstile>
          </div>
          <p-button type="submit" [disabled]="submitted || !form.valid || !form.dirty" i18n="login|Login button">Login</p-button>
        </form>
      } @else {
        <form [formGroup]="tanForm" class="flex flex-col gap-5" (ngSubmit)="onTanSubmit()">
          @for (tanError of tanErrors; track tanError) {
            <p-message i18n="login|Entered wrong TAN error" severity="error">
              {{ tanError }}
            </p-message>
          }
          <div class="flex flex-col gap-1">
            @if (tanMethod === 'email') {
              <label for="login-tan" i18n="login|Email TAN field label">Email TAN</label>
            } @else {
              <label for="login-tan" i18n="login|Authenticator app field label">Authenticator app</label>
            }
            <input pInputText [pAutoFocus]="true" autocomplete="off" id="login-tan" formControlName="tan" [fluid]="true" [invalid]="tanErrors.length > 0 || tanForm.get('tan')?.errors" />
            @if (tanForm.get('tan')?.touched && tanForm.get('tan')?.errors?.['required']) {
              <p-message i18n="login|TAN required error" severity="error" variant="simple" size="small">
                Tan is required
              </p-message>
            }
          </div>
          <div class="flex flex-col gap-1">
            <p-button type="submit" [disabled]="tanFormSubmitted || !tanForm.valid" i18n="login|Login button TAN form">Login</p-button>
          </div>
        </form>
      }
   </div>
  </div>

  <app-footer-links></app-footer-links>
</div>
